export const LOGIN = "/officer/oauth?ssotoken="
export const COUNT = "/officer/count"
export const TICKET_BY_STATUS = "/ticket"
export const ONE_TICKET = "/officer/ticket/"
export const UPDATE_TICKET = "/officer/ticket/action/"
export const GET_SUMMARY = "/officer/summary?"
export const ADD_SCHOOL_IMAGE = "/officer/report/school"
export const ADD_VC_IMG = "/officer/report/vcnode"
export const SCHOOL_VC_DATA = "/officer/report/user-wise"
export const SCHOOL_UPLOAD_HISTORY = "/officer/report/school/history"
export const VC_UPLOAD_HISTORY = "/officer/report/vcnode/history"
